import React from 'react';
import { Table, Badge, Button, Avatar } from '@/components/ui';
import type { MaintenanceRoute, RouteStatus } from '../types/routes.types';

export interface RouteTableProps {
  data: MaintenanceRoute[];
  isLoading: boolean;
  onEdit: (item: MaintenanceRoute) => void;
  onRowClick: (item: MaintenanceRoute) => void;
}

const statusColors: Record<RouteStatus, string> = {
  draft: 'bg-slate-100 text-slate-500',
  active: 'bg-emerald-100 text-emerald-600',
  inactive: 'bg-slate-100 text-slate-400',
  assigned: 'bg-blue-100 text-blue-600',
  in_progress: 'bg-amber-100 text-amber-600',
  completed: 'bg-indigo-100 text-indigo-600',
  cancelled: 'bg-red-100 text-red-600',
  archived: 'bg-slate-200 text-slate-700',
};

const statusLabels: Record<RouteStatus, string> = {
  draft: 'Bản nháp',
  active: 'Hoạt động',
  assigned: 'Đã giao',
  in_progress: 'Đang đi',
  completed: 'Xong',
  cancelled: 'Hủy',
  archived: 'Lưu trữ',
  inactive: 'Tạm dừng',
};

export function RouteTable({ data, isLoading, onEdit, onRowClick }: RouteTableProps) {
  return (
    <Table
      columns={[
        { key: 'code', title: 'Mã tuyến' },
        { key: 'name', title: 'Tên lộ trình' },
        { key: 'team', title: 'Tổ phụ trách' },
        { key: 'assignee', title: 'Trưởng tuyến' },
        { key: 'stops', title: 'Stops', align: 'center' },
        { key: 'status', title: 'Trạng thái', align: 'center' },
        { key: 'actions', title: '', align: 'right' },
      ]}
      data={data}
      isLoading={isLoading}
      onRowClick={onRowClick}
      renderCell={(item, key) => {
        switch (key) {
          case 'code':
            return <span className="font-mono text-[11px] font-bold text-slate-400  tracking-wider">{item.code}</span>;
          case 'name':
            return (
              <div className="flex flex-col">
                <span className="font-bold text-slate-900">{item.name}</span>
                <span className="text-[10px] text-slate-500 font-medium">{item.project?.name}</span>
              </div>
            );
          case 'team':
            return <span className="text-sm font-medium text-slate-600 bg-slate-50 px-2 py-1 rounded-lg border border-slate-100">{item.team?.name || '---'}</span>;
          case 'assignee':
            return (
              <div className="flex items-center gap-2">
                <Avatar src={item.assignee?.avatar_url} name={item.assignee?.full_name} size="xs" />
                <span className="text-xs font-bold text-slate-700">{item.assignee?.full_name || 'Chưa gán'}</span>
              </div>
            );
          case 'stops':
            return (
              <div className="flex flex-col items-center">
                <span className="font-black text-os-primary">{item.stops_count || 0}</span>
                <span className="text-[9px] text-slate-400  font-bold">Điểm</span>
              </div>
            );
          case 'status':
            return (
              <Badge className={`${statusColors[item.status_code]} border-transparent text-[10px] font-bold `}>
                {statusLabels[item.status_code]}
              </Badge>
            );
          case 'actions':
            return (
              <div className="flex justify-end gap-1">
                <Button variant="ghost" size="sm" icon="ri-edit-line" onClick={(e) => { e.stopPropagation(); onEdit(item); }} />
              </div>
            );
          default:
            return null;
        }
      }}
    />
  );
}
